<template>
  <div>
    <v-container fluid>
      <material-card
        icon="mdi-clipboard-text"
        inline
        title="Edit Student Subject Diary"
      >
        <v-card-actions>
          <router-link :to="{ name: 'viewStudentSubjectDiary' }">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              top
              right
            >
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon></v-btn
            >
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="8">
                <label class="font-weight-medium body-2"> Class Work </label>
                <!-- <ckeditor required v-model="classwork" ref="ckeditorRef1"></ckeditor> -->
                <!-- <textarea class="input" rows="3" required clearable v-model="classwork" ref="ckeditorRef"></textarea> -->
                <quill-editor
                  v-model="classwork"
                  theme="snow"
                  ref="myQuillEditor"
                >
                </quill-editor>
              </v-col>
              <v-col cols="12" md="4">
                <label class="body-2 font-weight-medium">
                  Select Class Work File
                </label>
                <b-field class="file is-primary">
                  <b-upload
                    @input="onclassFilechange()"
                    v-model="classworkfile"
                    multiple
                    class="file-label"
                  >
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <div class="pink--text body-2">
                  [ Allowed files: .gif, .png, .jpg, .jpeg, .xlsx, .xls, .csv,
                  .doc, .pdf, .txt, .docx, .pptx, .pptm, .ppt, .xps,
                  .potx,.potm, .pot, thmx, .ppsx, .pps, .ppam, .ppa, .mp3, .wma,
                  .aac, .wav, .flac, .mp4, .avi, .m4p, .m4v, .wmv, .mov, .webm,
                  .mpg, .mp2, .mpeg, .mpe, .mpv, .ogg, .flv, .mkv ]
                </div>
                <span v-if="classworkfile.length > 0">
                  <v-chip
                    v-for="(file, i) in classworkfile"
                    :key="i"
                    color="primary"
                    label
                    outlined
                    class="ma-2"
                    close
                    @click:close="deleteclassworkfile(i)"
                  >
                    {{ file.name }}
                  </v-chip>
                </span>
              </v-col>

              <v-col cols="12" md="8">
                <label class="font-weight-medium body-2"> Home Work </label>
                <!-- <ckeditor required v-model="homework" ref="ckeditorRef2"></ckeditor> -->
                <!-- <textarea class="input" rows="3" required clearable v-model="homework" ref="ckeditorRef"></textarea> -->
                <quill-editor
                  v-model="homework"
                  theme="snow"
                  ref="myQuillEditor"
                >
                </quill-editor>
              </v-col>
              <v-col cols="12" md="4">
                <label class="body-2 font-weight-medium">
                  Select Home Work File
                </label>
                <b-field class="file is-primary">
                  <b-upload
                    @input="onhomeFilechange()"
                    v-model="homeworkfile"
                    multiple
                    class="file-label"
                  >
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <div class="pink--text body-2">
                  [ Allowed files: .gif, .png, .jpg, .jpeg, .xlsx, .xls, .csv,
                  .doc, .pdf, .txt, .docx, .pptx, .pptm, .ppt, .xps,
                  .potx,.potm, .pot, thmx, .ppsx, .pps, .ppam, .ppa, .mp3, .wma,
                  .aac, .wav, .flac, .mp4, .avi, .m4p, .m4v, .wmv, .mov, .webm,
                  .mpg, .mp2, .mpeg, .mpe, .mpv, .ogg, .flv, .mkv ]
                </div>
                <span v-if="homeworkfile.length > 0">
                  <v-chip
                    v-for="(file, i) in homeworkfile"
                    :key="i"
                    color="primary"
                    label
                    outlined
                    class="ma-2"
                    close
                    @click:close="deletehomeworkfile(i)"
                  >
                    {{ file.name }}
                  </v-chip>
                </span>
              </v-col>

              <v-col cols="12" md="8">
                <label class="font-weight-medium body-2"> Description </label>
                <!-- <ckeditor required v-model="description" ref="ckeditorRef3"></ckeditor> -->
                <!-- <textarea class="input" rows="3" required clearable v-model="description" ref="ckeditorRef"></textarea> -->
                <quill-editor
                  v-model="description"
                  theme="snow"
                  ref="myQuillEditor"
                >
                </quill-editor>
              </v-col>
              <v-col cols="12" md="4">
                <label class="body-2 font-weight-medium">
                  Select Description File
                </label>
                <b-field class="file is-primary">
                  <b-upload
                    @input="onFilechange()"
                    v-model="discriptionfile"
                    multiple
                    class="file-label"
                  >
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <div class="pink--text body-2">
                  [ Allowed files: .gif, .png, .jpg, .jpeg, .xlsx, .xls, .csv,
                  .doc, .pdf, .txt, .docx, .pptx, .pptm, .ppt, .xps,
                  .potx,.potm, .pot, thmx, .ppsx, .pps, .ppam, .ppa, .mp3, .wma,
                  .aac, .wav, .flac, .mp4, .avi, .m4p, .m4v, .wmv, .mov, .webm,
                  .mpg, .mp2, .mpeg, .mpe, .mpv, .ogg, .flv, .mkv ]
                </div>
                <span v-if="discriptionfile.length > 0">
                  <v-chip
                    v-for="(file, i) in discriptionfile"
                    :key="i"
                    color="primary"
                    label
                    outlined
                    class="ma-2"
                    close
                    @click:close="deletediscriptionfile(i)"
                  >
                    {{ file.name }}
                  </v-chip>
                </span>
              </v-col>
              <v-col cols="12">
                <span v-if="dropFile1.length > 0">
                  <label class="warning--text"
                    >Already Uploaded Documents</label
                  >
                  <div>
                    <v-chip
                      v-for="(file, i) in dropFile1"
                      :key="i"
                      color="primary"
                      label
                      outlined
                      class="mr-2 mt-2"
                      close
                      @click:close="deleteDropFile1(file.id)"
                    >
                      {{ file.name }}
                    </v-chip>
                  </div>
                </span>
                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    :disabled="hasClicked"
                    bottom
                    right
                    elevation="1"
                    color="primary"
                    type="submit"
                  >
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'editStudentSubjectDiary',
  props: ['studentDiaryID'],
  components: { MaterialCard, quillEditor },
  data () {
    return {
      total: 0,
      dropFile: [],
      classworkfile: [],
      homeworkfile: [],
      discriptionfile: [],
      viewclassworkfile: [],
      viewhomeworkfile: [],
      viewdiscriptionfile: [],
      classwork: '',
      discription: '',
      type: '',
      title: '',
      homework: '',
      description: '',
      studentDiary: [],
      documentData: [],
      hasClicked: false,
      loader: true,
      isLoading: false,
      sendData: {},
      selectedfranchiseeID: [],
      dropFile1: [],
      isWrite: false,
      deleteFileIdArr: [],
      loadingComponent: null,
      allowedFiles: [
        'gif',
        'png',
        'jpg',
        'jpeg',
        'xlsx',
        'xls',
        'csv',
        'doc',
        'pdf',
        'txt',
        'docx',
        'pptx',
        'pptm',
        'ppt',
        'xps',
        'potx',
        'potm',
        'pot',
        'thmx',
        'ppsx',
        'pps',
        'ppam',
        'ppa',
        'mp3',
        'wma',
        'aac',
        'wav',
        'flac',
        'mp4',
        'avi',
        'm4p',
        'm4v',
        'wmv',
        'mov',
        'webm',
        'mpg',
        'mp2',
        'mpeg',
        'mpe',
        'mpv',
        'ogg',
        'flv',
        'mkv'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.studentSubjectDiary()
    await this.studentSubjectDiaryDocuments()
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix
    // const that1 = this.$refs.ckeditorRef1
    // const that2 = this.$refs.ckeditorRef2
    // const that3 = this.$refs.ckeditorRef3
    // const maximizedState1 = that1.instance.getCommand('maximize').state
    // const maximizedState2 = that2.instance.getCommand('maximize').state
    // const maximizedState3 = that3.instance.getCommand('maximize').state

    // if (maximizedState1 === 1) {
    //   that1.instance.execCommand('maximize')
    // }
    // if (maximizedState2 === 1) {
    //   that2.instance.execCommand('maximize')
    // }
    // if (maximizedState3 === 1) {
    //   that3.instance.execCommand('maximize')
    // }
    // if (this.hasDataChanged() && !this.hasClicked) {
    //   return this.$dialog.warning({
    //     title: 'Leave Page',
    //     text: 'Do you really want to leave? you have unsaved changes!',
    //     actions: {
    //       false: 'No',
    //       true: {
    //         color: 'success',
    //         text: 'Yes',
    //         handle: () => {
    //           next()
    //         }
    //       }
    //     }
    //   })
    // } else
    next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const prevClassWork = this.studentDiary.classWork
      const prevHomeWork = this.studentDiary.homeWork
      const prevDescription = this.studentDiary.description
      console.log(prevClassWork, prevHomeWork, prevDescription)
      const boolAlert =
        this.classwork !== prevClassWork ||
        this.homework !== prevHomeWork ||
        this.description !== prevDescription ||
        this.classworkfile.length > 0 ||
        this.homeworkfile.length > 0 ||
        this.discriptionfile.length > 0
      return boolAlert
    },
    studentSubjectDiary: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/studentSubjectDairy/${this.studentDiaryID}`
        )
        this.studentDiary = data
        this.classwork = this.studentDiary.classWork
        this.description = this.studentDiary.description
        this.homework = this.studentDiary.homeWork
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    studentSubjectDiaryDocuments: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/studentSubjectDairy/${this.studentDiaryID}`
        )
        this.documentData = data
        this.dropFile1 = this.documentData.studentSubjectDairyDocuments
        if (this.dropFile1) {
          this.dropFile1.forEach((docID) => {
            docID.name = docID.urlKey.substring(
              docID.urlKey.lastIndexOf('/') + 1
            )
          })
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteclassworkfile (i) {
      this.classworkfile.splice(i, 1)
    },
    deletehomeworkfile (i) {
      this.homeworkfile.splice(i, 1)
    },
    deletediscriptionfile (i) {
      this.discriptionfile.splice(i, 1)
    },
    deleteDropFile1 (docID) {
      this.$dialog.warning({
        title: 'Deleting Image',
        text: '"Do you want to Delete this file"?',
        actions: {
          false: 'No',
          true: {
            color: 'success',
            text: 'Yes',
            handle: () => {
              this.dropFile1.forEach((element) => {
                if (docID === element.id) {
                  let index = this.dropFile1.indexOf(element)
                  if (index !== -1) {
                    this.dropFile1.splice(index, 1)
                  }
                  this.deleteFileIdArr.push(docID)
                }
              })
            }
          }
        }
      })
    },

    save: async function () {
      /** Remove Empty <p> tags classwork **/
      let classworkTest = this.classwork
      classworkTest = classworkTest.replace(/(<([^>]+)>)/gi, '')
      classworkTest = classworkTest.replace(/&nbsp;/g, '')
      classworkTest = classworkTest.trim()
      /** Remove Empty <p> tags homework **/
      let homeworkTest = this.homework
      homeworkTest = homeworkTest.replace(/(<([^>]+)>)/gi, '')
      homeworkTest = homeworkTest.replace(/&nbsp;/g, '')
      homeworkTest = homeworkTest.trim()
      /** Remove Empty <p> tags for description **/
      let descriptionTest = this.description
      descriptionTest = descriptionTest.replace(/(<([^>]+)>)/gi, '')
      descriptionTest = descriptionTest.replace(/&nbsp;/g, '')
      descriptionTest = descriptionTest.trim()

      if (
        (classworkTest === '' || classworkTest === null) &&
        (homeworkTest === '' || homeworkTest === null) &&
        (descriptionTest === '' || descriptionTest === null)
      ) {
        return this.$dialog.message.warning(
          'Please Fill Altleast One Of These Data(ClassWork (or) HomeWork (or) Discription)',
          {
            position: 'top',
            timeout: 4000
          }
        )
      }
      if (this.deleteFileIdArr.length > 0) {
        this.deleteFileIdArr.forEach((docID) => {
          this.deleteDocument(docID)
        })
      }
      let formData = new FormData()
      formData.append('classWork', this.classwork)
      formData.append('homeWork', this.homework)
      formData.append('description', this.description)
      for (let i = 0; i < this.classworkfile.length; i++) {
        formData.append('classWorkfile', this.classworkfile[i])
      }
      for (let i = 0; i < this.homeworkfile.length; i++) {
        formData.append('homeWorkfile', this.homeworkfile[i])
      }
      for (let i = 0; i < this.discriptionfile.length; i++) {
        formData.append('descriptionfile', this.discriptionfile[i])
      }
      this.hasClicked = true
      try {
        await http.put(
          `${constants.API_URL}/api/communication/studentSubjectDairy/${this.studentDiaryID}`,
          formData
        )
        this.loader = false
        this.$dialog.info({
          title: 'Success',
          text: 'Saved successfully'
        })
        return this.$router.push({ name: 'viewStudentSubjectDiary' })
      } catch (e) {
        this.loader = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    download: async function (i) {
      try {
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    deleteDocument: async function (deldocID) {
      try {
        this.isLoading = true
        await http.get(
          `${constants.API_URL}/api/communication/studentSubjectDairy/status/${deldocID}`
        )
        this.isLoading = false
        // this.studentSubjectDiaryDocuments()
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    onclassFilechange () {
      let r = this.classworkfile.some((a) => {
        return !this.allowedFiles.includes(a.name.split('.').pop())
      })
      if (r === true) {
        this.classworkfile.pop()
        return this.$dialog.error({
          text: 'Kindly select allowed file formats only!',
          title: 'Error'
        })
      }
    },
    onhomeFilechange () {
      let r = this.homeworkfile.some((a) => {
        return !this.allowedFiles.includes(a.name.split('.').pop())
      })
      if (r === true) {
        this.homeworkfile.pop()
        return this.$dialog.error({
          text: 'Kindly select allowed file formats only!',
          title: 'Error'
        })
      }
    },
    onFilechange () {
      let r = this.discriptionfile.some((a) => {
        return !this.allowedFiles.includes(a.name.split('.').pop())
      })
      if (r === true) {
        this.discriptionfile.pop()
        return this.$dialog.error({
          text: 'Kindly select allowed file formats only!',
          title: 'Error'
        })
      }
    }
  }
}
</script>
<style scoped>
textarea {
  background-color: #ffffff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  height: 9.5rem;
}
</style>
